'use strict';

function clearAllBtnSelected(btn) {
    const container = $(btn).parent();
    container.children().each((index, button) => {
        if ($(button).hasClass('selected')) {
            $(button).removeClass('selected');
        }
    });
}

function clearAllCheckboxes(checkbox) {
    const checkboxes = $(checkbox)
        .closest('.form-group')
        .find('input[type=checkbox]:checked');
    checkboxes.each((index, check) => {
        if (check !== checkbox) {
            $(check).prop('checked', false);
        }
    });
}

function reloadFilterNav() {
    const nav = $('.filter-active-nav');
    const filterColumn = $('.filter-column');
    nav.empty();
    const allSelectedFilters = filterColumn.find('.selected');
    const allCheckedFilters = filterColumn.find('input[type=checkbox]:checked');
    let newElement, value;
    let elements = [];
    allSelectedFilters.each((index, filter) => {
        newElement = $("<div class='btn filter-selected d-flex align-items-center justify-content-center'><span></span></div>").text(filter.innerText);
        elements.push(newElement);
    });
    allCheckedFilters.each((index, filter) => {
        value = $(filter).val();
        newElement = $("<div class='btn filter-selected d-flex align-items-center justify-content-center'><span></span></div>").text(value);
        elements.push(newElement);
    });
    nav.append(elements);
}

$(document).ready(function() {
    reloadFilterNav();
    const filterButtons = $('.filter-bar').find('.btn-travels');
    filterButtons.on('click', function() {
        $('.filter-column').toggle();
        filterButtons.each((index, button) => {
            if ($(button).hasClass('d-none')) {
                $(button).removeClass('d-none');
            } else {
                $(button).addClass('d-none');
            }
        });
    });

    $('.btn-badge').on('click', function() {
        if ($(this).hasClass('selected')) {
            clearAllBtnSelected(this);
            reloadFilterNav();
        } else {
            clearAllBtnSelected(this);
            $(this).addClass('selected');
            reloadFilterNav();
        }
    });

    $('input:checkbox').change(function() {
        clearAllCheckboxes(this);
        reloadFilterNav();
    });
});
